"use client"

import { lazy, Suspense } from 'react'
import { useStore } from '@/lib/store'
import { useFeature } from '@/hooks/use-feature'
import { useWaiterAccess } from '@/lib/use-waiter-access'

const RequestReceiver = lazy(() => import('./request-receiver'))

/**
 * 1.69 (198) — the guests' requests reach the till on any page (spec §5.4; Codex #8): light here — the receiver loads
 * only on an owner's or a cashier's device of a shop with the tables and the table QR on, or while requests it already
 * read are still open (the switch turned off mid-service strands nothing). Never a waiter's phone (it has its own list,
 * 1.67's app), the accountant or a support session. A new shop or branch remounts it: nothing carries over.
 */
export function RequestReceiverMount() {
  const tablesOn = useFeature('tables')
  const qrOn = useFeature('tableQr')
  const hydrated = useStore((s) => s.isHydrated)
  const orgId = useStore((s) => s.currentOrg?.id ?? null)
  const branchId = useStore((s) => s.activeBranchId)
  const open = useStore((s) => (s.guestRequests?.length ?? 0) > 0)
  const role = useStore((s) => s.userRole)
  const support = useStore((s) => !!s.supportSession)
  const waiter = useWaiterAccess()
  if (!hydrated || !tablesOn || support || waiter !== 'none' || (role !== 'owner' && role !== 'cashier')) return null
  if (!qrOn && !open) return null
  return (
    <Suspense fallback={null}>
      <RequestReceiver key={`${orgId}:${branchId}`} />
    </Suspense>
  )
}
